export const colors = {
  contrastThreshold: 7,
  white: '#FFFFFF',
  black: '#141414',

  lightText: '#FFFFFF',
  darkText: '#141414',

  primary: {
    '50': '#FFFFFF',
    '100': '#EEEEEE',
    '200': '#DDDDDD',
    '300': '#CCCBCB',
    '400': '#BBBABA',
    '500': '#AAA9A9',
    '600': '#7E7D7D',
    '700': '#525252',
    '800': '#262626',
    '900': '#1D1D1D',
    '1000': '#141414',
    main: '#1D1D1D',
    text: '#FFFFFF',
  },
  error: {
    '50': '#fef2f2',
    '100': '#fee2e2',
    '200': '#fecaca',
    '300': '#fca5a5',
    '400': '#f87171',
    '500': '#ef4444',
    '600': '#dc2626',
    '700': '#b91c1c',
    '800': '#991b1b',
    '900': '#7f1d1d',
    main: '#ef4444',
    text: '#000000',
  },
  success: {
    '50': '#ECFDF3',
    '100': '#C0EFD8',
    '200': '#95E1BC',
    '300': '#69D3A1',
    '400': '#3EC585',
    '500': '#12B76A',
    '600': '#0F9E5C',
    '700': '#0C854E',
    '800': '#0A6B40',
    '900': '#075232',
    '1000': '#043924',
    main: '#12B76A',
    text: '#000000',
  },
  warning: {
    '50': '#FFFCF5',
    '100': '#FFEDCB',
    '200': '#FEDEA1',
    '300': '#FECE76',
    '400': '#FDBF4C',
    '500': '#FDB022',
    '600': '#D5911C',
    '700': '#AD7116',
    '800': '#845211',
    '900': '#5C320B',
    '1000': '#341305',
    main: '#FDB022',
    text: '#000000',
  },
  info: {
    '0': '#F6FAFF',
    '100': '#E4EFFF',
    '200': '#060F1C',
    '300': '#C8DFFD',
    '400': '#96BFF9',
    '500': '#5A97EB',
    '600': '#1D6BD7',
    '700': '#2462B9',
    '800': '#24559A',
    '900': '#1C4680',
    '1000': '#163561',
    main: '#5A97EB',
  },
  muted: {
    '50': '#FFFFFF',
    '100': '#EEEEEE',
    '200': '#DDDDDD',
    '300': '#CCCBCB',
    '400': '#BBBABA',
    '500': '#AAA9A9',
    '600': '#7E7D7D',
    '700': '#525252',
    '800': '#262626',
    '900': '#1D1D1D',
    '1000': '#141414',
    main: '#AAA9A9',
    text: '#000000',
  },
};
